<template>
    <el-dialog :visible.sync="dialogVisible" title="选择采购订单" style="margin-top: 8vh;margin-left: 13vh;z-index: 3000;" width="1000px"
       :modal-append-to-body="false" :modal="true">
        <el-form :model="searchForm" @submit.native.prevent size="mini" inline>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item>
                        <div class="input-with-select">
                            <span class="prepend-text">采购单号</span>
                            <el-input v-model="searchForm.purchaseOrderNo" placeholder="请输入"></el-input>
                        </div>
                    </el-form-item>
                </el-col>

                <!-- 修改后的商品编码搜索部分 -->
                <el-col :span="8">
                    <el-form-item>
                        <div class="input-with-select">
                            <div style="display: flex; align-items: center; width: 210px;">
                                <span class="prepend-text">退货商品</span>
                                <el-input v-model="searchForm.purchaseOrderItem" placeholder="请输入" clearable style="width: 120px;"
                                    class="value-select">
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                </el-col>

                <el-col :span="8" class="input-with-select">
                    <el-button type="primary" @click="searchGoods" size="mini">查询</el-button>
                    <el-button @click="resetSearch" size="mini">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <!-- 其余部分保持不变 -->
        <div v-loading="loading">
            <lb-table v-horizontal-scroll='"always"' border :column="columns" align="center" :data="goodsList"
                pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5, 10, 20, 30, 50, 200]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
                @size-change="handleSizeChange" @p-current-change="handleCurrentChange" @refresh="fetchData"
                :orderStatistics="page.totalNum" is-goods-selector statisticText="当前列表统计总商品数"
                @selection-change="handleTableSelectionChange" ref="tableRef">
            </lb-table>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmSelection" size="mini">提交</el-button>
            <el-button @click="dialogVisible = false" size="mini">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import LbTable from '@/pages/purchase/components/lb-table/lb-table'

export default {
    components: {
        LbTable,
    },
    name: 'PurchaseOrder',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchForm: {
                name: '',
                // 不再直接使用code字段
                categoryValue: '',
                purchaseOrderNo: '',
                purchaseOrderItem: '',
            },
            // 新增代码搜索类型和值
            codeSearchType: 'code', // 默认选择商品编码
            codeSearchValue: '',
            dialogVisible: false,
            goodsList: [],
            selectedGoods: [],
            loading: false,
            page: {
                currentPage: 1,
                pageSize: 10,
                totalNum: 0
            },
            queryForm: {
                categoryType: ''
            },
            columns: [
                {
                    type: 'selection',
                    width: '60',
                    slot: true
                },
                {
                    label: '序号',
                    prop: 'index',
                    width: '55',
                    render: (h, scope) => {
                        const index = (this.page.currentPage - 1) * this.page.pageSize + scope.$index + 1;
                        return h('div', index);
                    }
                },
                {
                    label: '采购单号',
                    prop: 'purchaseOrderNo',
                    width: '120'
                },
                {
                    label: '采购商品',
                    prop: 'purchaseOrderItem',
                    width: '120'
                },
                {
                    label: '申请采购单号',
                    prop: 'applicationNo',
                    width: '120',
                },
                {
                    label: '采购类型',
                    prop: 'purchaseTypeLabel',
                    width: '120'
                },
                {
                    label: '采购申请人',
                    prop: 'applicantName',
                    width: '120'
                },
                {
                    label: '退货数',
                    prop: 'returnQuantity',
                    width: '120'
                },
                {
                    label: '退货金额（元）',
                    prop: 'returnAmount',
                    width: '120'
                },
            ],
        };
    },
    created() {
        this.searchGoods();
    },
    watch: {
        // 监听visible prop的变化
        visible: {
            immediate: true,
            handler(newVal) {
                this.dialogVisible = newVal;
            }
        },
        // 监听dialogVisible的变化，通知父组件
        dialogVisible(newVal) {
            this.$emit('update:visible', newVal);
        }
    },
    methods: {
        show() {
            this.dialogVisible = true;
            // 清空选中状态 - 使用组件暴露的方法
            this.$nextTick(() => {
                if (this.$refs.tableRef) {
                    this.$refs.tableRef.clearSelection();
                }
            });
            this.selectedGoods = [];
            this.searchGoods();
        },
        handleTableSelectionChange(selection) {
            // 将多选行为强制为单选：仅保留本次新增选中的那一项
            const currentSelection = Array.isArray(selection) ? selection : [];
            if (currentSelection.length <= 1) {
                this.selectedGoods = currentSelection;
                return;
            }

            // 找出本次新增选中的项（相较于上一次的 selectedGoods）
            const newlySelected = currentSelection.find(item => !this.selectedGoods.some(sel => sel.id === item.id))
                || currentSelection[currentSelection.length - 1];

            this.selectedGoods = newlySelected ? [newlySelected] : [];

            // 同步到表格的勾选状态，只保留一个
            this.$nextTick(() => {
                if (this.$refs && this.$refs.tableRef) {
                    this.$refs.tableRef.clearSelection();
                    if (newlySelected) {
                        this.$refs.tableRef.toggleRowSelection(newlySelected, true);
                    }
                }
            });
        },
        // 提交时获取当前选中行
        confirmSelection() {
            // ✅ 修改：通过组件实例获取选中项
            let selected = [];
            if (this.$refs.tableRef) {
                // lb-table 组件应该通过 $refs.tableRef 暴露选中项
                // 如果组件没有直接暴露，可能需要通过其他方式获取
                selected = this.selectedGoods; // 使用已经维护的 selectedGoods
            }

            console.log('确认选择时的选中商品:', selected);

            if (!selected || selected.length === 0) {
                this.$message.warning('请至少选择一个商品');
                return;
            }

            // 为每个选中的采购订单获取详细的商品信息
            const promises = selected.map(order => this.$api.srmSurchaseOrderDetail({ id: order.id }));

            Promise.all(promises).then(results => {
                const ordersWithItems = results.map((res, index) => ({
                    ...selected[index],
                    items: res.data.items || []
                }));

                // 发射选中事件，传递选中的数据
                this.$emit('selected', ordersWithItems);
                this.dialogVisible = false;

                // 清除选中状态
                this.$nextTick(() => {
                    if (this.$refs.tableRef) {
                        this.$refs.tableRef.clearSelection();
                    }
                });
            }).catch(error => {
                console.error('获取订单详情失败:', error);
                this.$message.error('获取订单详情失败');
            });
        },

        // 查询时同步已选状态（可选增强体验）
        searchGoods() {
            this.loading = true;
            const params = {
                pageNo: this.page.currentPage,
                pageSize: this.page.pageSize,
                purchaseType: 1, // 采购类型：1-办公用品，2-销售用品
                name: this.searchForm.name,
                [this.codeSearchType]: this.codeSearchValue,
                categoryType: this.queryForm.categoryType,
                categoryValue: this.searchForm.categoryValue,
                purchaseOrderNo: this.searchForm.purchaseOrderNo,
                purchaseOrderItem: this.searchForm.purchaseOrderItem,
                applicationNo: this.searchForm.applicationNo,
                status: 1,
            }

            this.$api.srmSurchaseOrderPage(params).then(res => {
                if (res.code === 0) {
                    this.goodsList = res.data.list;
                    console.log('查询结果:', this.goodsList);

                    this.page.totalNum = res.data.totalNum;

                    // ✅ 修改：直接调用 lb-table 暴露的方法
                    this.$nextTick(() => {
                        if (this.$refs.tableRef) {
                            // 清空当前选择
                            this.$refs.tableRef.clearSelection();

                            // 设置选中状态
                            this.goodsList.forEach(row => {
                                const isSelected = this.selectedGoods.some(sel => sel.id === row.id);
                                if (isSelected) {
                                    this.$refs.tableRef.toggleRowSelection(row, true);
                                }
                            });
                        }
                    });
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        // 添加重置选中状态的方法
        resetSelection() {
            this.selectedGoods = [];
            this.goodsList.forEach(item => {
                item.selected = false;
            });
        },
        resetSearch() {
            this.searchForm.name = '';
            this.searchForm.categoryValue = '';
            this.codeSearchType = 'code'; // 重置为默认值
            this.codeSearchValue = '';
            this.queryForm.categoryType = '';
            this.searchForm.purchaseOrderNo = '';
            this.page.currentPage = 1;
            this.searchForm.purchaseOrderItem = '';
            this.searchGoods();
        },
        handleCategoryTypeChange(value) {
            // 分类类型改变的处理逻辑
            console.log('分类类型改变:', value);
        },
        handleSizeChange(size) {
            this.page.pageSize = size;
            this.searchGoods();
        },
        handleCurrentChange(page) {
            this.page.currentPage = page;
            this.searchGoods();
        },
        fetchData() {
            this.searchGoods();
        }
    }
};
</script>

<style lang="scss" scoped>
/* 样式保持不变 */
.dialog-footer {
    text-align: right;
    padding: 10px 0;
}

.form-item-inline {
    margin-bottom: 0;
}

/* 下拉框组样式 */
.input-with-select {
    margin-top: 20px;
    display: flex;
    align-items: center;

    /deep/ {
        .el-input__inner {
            font-weight: 400;
            font-size: 12px;
            width: 120px;
            border-radius: 0;
            height: 24px;
            line-height: 24px;

        }
    }

    .prepend-text {
        width: 90px;
        flex-shrink: 0;
        background-color: #F5F7FA;
        border: 1px solid #DCDFE6;
        border-right: none;
        font-size: 12px;
        color: #909399;
        font-family: Arial;
        height: 24px;
        line-height: 22px;
        box-sizing: border-box;
        padding: 0 0 0 6px;
        border-radius: 4px 0 0 4px;
    }

    .category-select {
        ::v-deep .el-input__inner {
            font-weight: 400;
            font-size: 12px;
            width: 160px;
            border-radius: 0;
            background-color: #F5F7FA;
            height: 24px;
            line-height: 24px;
            padding: 0 0 0 6px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;

        }
    }

    .value-select {
        ::v-deep .el-input__inner {
            border-radius: 0 4px 4px 0;

            height: 24px;
            line-height: 24px;
        }

        ::v-deep .el-select__caret {
            line-height: 24px;
        }
    }
}

.form-buttons {
    display: flex;
    align-items: center;
    height: 32px;
}
</style>